module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Router', {
		configure: function() {
			this.registerOptions('', {
				'routes': {
					'@': '>home',
					'@home': '#home #home',
					'@miss' : '#home #404'
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this._compiles = [];
			this.routes = {};
			var map = this.getOption('map');
			if (map) { //old map format
				this.convertMapToRoutes(map);
			}
			if (this.getOption('routes')) {
				this.addRoutes(this.getOption('routes'));
			}
			
			if (map && map.routes) {
				this.addRoutes(map.routes);
			}

			if (this.getOption('navigator')) {
				this.handleEvent(this.getOption('navigator'), 'modified', function(diff, widget) {
					var location = [];
					fox.each(widget.objHash, function(value, name) {
						if (fox.isNumeric(name)) {
							location.push(value);
						}
					});
					this.navigate(location.join('/'));
				}, {listenHistory: true, prefix: 'foxrouter'});
			}

			var router = fox.Router || Object.defineProperty(fox, 'Router', {
				get: function() {return this._wom.getRoot().rwom1(this._wom.getRoot().getOption('routerPath') || '.Router');}.bind(this)
			});

			this.callParent('init', arguments);
		},

		navigate: function(path) {
			var passedRoute = false;

			if (path[0] === '>') {
				passedRoute = {action: path};
			} else {
				this._compiles.some(function (route) {
					var match = path.match(route.re);
					var params = {};

					if (match === null) return false;

					fox.each(route.index, function(i, name) {
						params[name] = match[i];
					});

					passedRoute = {action: route.action, params: params, path: path};
					
					return true;
				}, this);
			}

			if (passedRoute) {
				this.hookWrapper('setActiveRoute', passedRoute);
			} else {
				this.hookWrapper('setActiveRoute', {
					action: this.routes['@' + path] || this.routes['@miss'] || {},
					path: path,
					params: {}
				});
			}

			this.hookWrapper('execute');
		},

		setActiveRoute: function (route) {
			this._passedRoute = route;
		},

		execute: function() {
			var passedRoute = this._passedRoute;
			fox.log('execute', passedRoute);

			if (fox.isObject(passedRoute.action) &&
				passedRoute.action.hasOwnProperty('checker') &&
				fox.isFunction(passedRoute.action.checker)) {
				var checkerRes = passedRoute.action.checker(passedRoute);

				if (!checkerRes) {
					passedRoute.action = passedRoute.action.action;
				} else {
					return this.navigate(checkerRes);
				}
			}

			if (fox.isFunction(passedRoute.action)) {
				return this.navigate(passedRoute.action(passedRoute));
			}
			if (fox.wom.isSelector(passedRoute.action)) {
				var w = fox.wom.selectFirst(passedRoute.action), parents, parent;
				if (!w) {
					parents = passedRoute.action.split(' ').reverse();
				} else {
					parents = [w];
					parent = w.getParent();
					while (parent) {
						if (parent.isActive()) {
							break;
						}
						parents.push(parent);
						parent = parent.getParent();
					}
				}

				var prefix = '@root ', fail;
				var fail = parents.reverse().some(function (w) {
					if (fox.wom.isSelector(w)) {
						prefix = prefix + w + ' ';
						w = fox.wom.selectFirst(prefix);

						if (!w) {
							console.log('Cannot find action widget ', passedRoute);
							return true;
						}
					}

					var parent = w.getParent();
					var oldValue = parent.getOption('widgetGroupInfo.' + w.getGroup() + '.manualActivation');
					parent.setOption('widgetGroupInfo.' + w.getGroup() + '.manualActivation', true);
					parent.switchEmbeddedWidget(w.getAlias(), passedRoute.params);
					parent.setOption('widgetGroupInfo.' + w.getGroup() + '.manualActivation', oldValue);

					return false;
				});
				
				if (fail) return;

				if (this._wom.getRoot().handleFoxReady) {
					this._wom.getRoot().handleFoxReady();
				}
			} else if (passedRoute.action[0] == '>') {
				var redirect = passedRoute.action.substr(1);
				if (redirect.indexOf('http') === 0) {
					fox.Navigator.update({0: 'home'}, true);
					document.location.href = redirect;
				} else {
					if (redirect[0] == '>') {
						fox.Navigator.update({0: redirect.substr(1)}, 2);
					} else {
						fox.Navigator.set(0, redirect);
					}
				}
			}
		},

		convertMapToRoutes: function(map) {
			var routes = {};
			fox.each(map.pages, function(widgetAlias, pageAlias) {
				if (widgetAlias[0] == '@') {
					routes[pageAlias + '(/*tail)'] = widgetAlias.replace('@', '>');
				} else {
					routes[pageAlias + '(/*tail)'] = '#' + widgetAlias + ' #' + pageAlias;
				}
			}, this);
			fox.each(map.denied, function(reason, pageAlias) {
				var action = reason;
				while (map.special[action] && map.special[action] != action) {
					action = map.special[action];
				}
				
				if (!action) {
					return;
				}
				
				if (fox.isFunction(action)) {
					routes[pageAlias + '(/*tail)'] = action;
				} else {
					routes[pageAlias + '(/*tail)'] = routes[action + '(/*tail)'] || routes[action] || function() {return 'join'};
				}
			}, this);
			this.addRoutes(routes);
		},

		addRoute: function(route, action) {
			this.routes[route] = action;
			this._compile();
		},

		addRoutes: function(routes) {
			this.routes = fox.merge(this.routes, routes);
			this._compile();
		},

		_compile: function() {
			var wAddendum = function(str) {
				return str.match(/^>*/g, str)[0].length - str.match(/^<*/g, str)[0].length;
			};var tmp = {};
			var routes = fox.getObjectKeys(this.routes).sort(function(a, b) {
				var aWeight = a.split(/[*:/]/).length + wAddendum(a),
					bWeight = b.split(/[*:/]/).length + wAddendum(b);tmp[a]=aWeight;tmp[b]=bWeight;
				return aWeight < bWeight ? 1 : (aWeight == bWeight ? 0 : -1);
			});
			this._compiles = [];
			var optionalParam = /\((.*?)\)/g;
			var namedParam    = /(\(\?)?:(\w+)/g;
			var splatParam    = /\*(\w+)/g;
			var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
			var addendumParam = /^([<>]*)/g;
			
			fox.each(routes, function(route) {
				if (route[0] == '@') {
					return;
				}
				var tmp = route.replace(escapeRegExp, '\\$&')
					.replace(addendumParam, '')
					.replace(optionalParam, '($1)?')
					.replace(namedParam, function(match, optional, name) {
						return optional ? match : '(<' + name + '>[^/?]+)';
					})
					.replace(splatParam, '(<$1>[^?]*?)');
				var index = {};
				tmp = tmp.replace(/\((\<(\w+)\>)/g, function(match, tag, name, len, source) {
					index[name] = source.substr(0, len).split('(').length;
					return '(';
				});

				this._compiles.push({re: new RegExp('^' + tmp + '(?:\\?([\\s\\S]*))?$', 'i'), action: this.routes[route], index: index});
			}, this);
		}

	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/router.js
// module id = 220
// module chunks = 0